import MuiPopover, { PopoverProps } from '@mui/material/Popover';

export interface IPopoverProps extends PopoverProps {}

const Popover = (props: IPopoverProps): JSX.Element => {
  return <MuiPopover {...props} />;
};

export default Popover;
